module.exports = __webpack_public_path__ + "static/img/outlook-icon.9fb38e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/integrations/outlook-icon.png
// module id = 1427
// module chunks = 1